import "./styles.css";
import { ImmigrantDefenseGame } from "./game/Game";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("Application root is missing");

app.innerHTML = `
  <main class="game-shell" data-state="menu">
    <header class="game-header">
      <a class="mini-brand" href="/" aria-label="Immigrant Defense home"><span>🧱</span> IMMIGRANT DEFENSE</a>
      <div class="header-actions">
        <button id="sound-button" type="button" aria-label="Mute sound">◖))</button>
        <button id="fullscreen-button" type="button" aria-label="Fullscreen">⛶</button>
        <button id="pause-button" type="button" aria-label="Pause">Ⅱ</button>
      </div>
    </header>
    <section class="game-stage" aria-label="Immigrant Defense game">
      <canvas id="game-canvas" aria-label="Desert border crossing. Build towers along the winding path and stop crossers before they reach the wall."></canvas>
      <div id="wave-banner" class="wave-banner" role="status"></div>
      <div class="hud" aria-live="polite">
        <div><span>CASH</span><strong id="cash">$0</strong></div>
        <div><span>WAVE</span><strong id="wave">—</strong></div>
        <div class="streak-box"><span>STREAK</span><strong id="streak">—</strong></div>
        <div class="lives-box"><span>BORDER</span><strong id="lives">▮▮▮</strong></div>
        <div><span>SCORE</span><strong id="score">0</strong></div>
        <div><span>BEST</span><strong id="best">0</strong></div>
      </div>
      <div id="game-overlay" class="game-overlay"></div>
    </section>
    <section class="command-bar">
      <div id="build-bar" class="build-bar" aria-label="Build towers and use powers"></div>
      <div class="command-side">
        <div id="tower-panel" class="tower-panel"></div>
        <button id="next-wave" type="button" class="next-wave">NEXT WAVE</button>
      </div>
    </section>
    <footer class="game-footer">
      <span>Build next to the dirt road · Don't let them reach the wall</span>
      <span><kbd>P</kbd> pause <kbd>M</kbd> mute <kbd>Enter</kbd> start</span>
    </footer>
  </main>
`;

const required = <T extends Element>(selector: string): T => {
  const element = app.querySelector<T>(selector);
  if (!element) throw new Error(`Required element is missing: ${selector}`);
  return element;
};

new ImmigrantDefenseGame({
  shell: required(".game-shell"),
  canvas: required("#game-canvas"),
  overlay: required("#game-overlay"),
  banner: required("#wave-banner"),
  cash: required("#cash"),
  wave: required("#wave"),
  lives: required("#lives"),
  streak: required("#streak"),
  score: required("#score"),
  best: required("#best"),
  buildBar: required("#build-bar"),
  towerPanel: required("#tower-panel"),
  nextWaveButton: required("#next-wave"),
  pauseButton: required("#pause-button"),
  soundButton: required("#sound-button"),
  fullscreenButton: required("#fullscreen-button"),
});
